const state = {
    sm_stocks: [],
    sm_stock: {},
    sm_stock_product_info: {},
}

export default state;
